export enum RelationshipDesignationTypes {
  DESCENDANT = 'DESCENDANT',
  GRANDCHILD = 'GRANDCHILD',
  NAMED = 'NAMED',
  UNKNOWN = '',
}
